export const NavListActing = [
    { path: "/acting", linkName: "Home" },
    { path: "media", linkName: "Media" },
    { path: "resume", linkName: "Resume" }
];

export const NavListMusic = [
    { path: "/music", linkName: "Home" },
    { path: "discography", linkName: "Discography" },
    { path: "about", linkName: "About" }
];